/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_A2Inputs */

const en_guide_what_is_json_faq_a2 = /** @type {(inputs: Guide_What_Is_Json_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Standard JSON does not support comments. If you need comments in configuration files, consider using JSONC (JSON with Comments) or YAML instead. Some tools like VS Code support JSONC for their config files.`)
};

const ko_guide_what_is_json_faq_a2 = /** @type {(inputs: Guide_What_Is_Json_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 표준 JSON은 주석을 지원하지 않습니다. 설정 파일에 주석이 필요하다면 JSONC(JSON with Comments)나 YAML을 사용하는 것을 고려하세요. VS Code 같은 일부 도구는 설정 파일에 JSONC를 지원합니다.`)
};

const ja_guide_what_is_json_faq_a2 = /** @type {(inputs: Guide_What_Is_Json_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。標準のJSONはコメントをサポートしていません。設定ファイルにコメントが必要な場合は、JSONC（JSON with Comments）やYAMLの使用を検討してください。VS Codeなどのツールは設定ファイルにJSONCをサポートしています。`)
};

/**
* | output |
* | --- |
* | "No. Standard JSON does not support comments. If you need comments in configuration files, consider using JSONC (JSON with Comments) or YAML instead. Some too..." |
*
* @param {Guide_What_Is_Json_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_a2 = /** @type {((inputs?: Guide_What_Is_Json_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_a2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_a2(inputs)
	return ja_guide_what_is_json_faq_a2(inputs)
});